import { useEffect } from "react";
import "./PayPalSubscriptionButtons.scss"
import { trackPurchase } from "../../utils/facebookPixel";

export default function PayPalMonthlyButtons({ setSubscriptionID, clientId, planId, isSandbox }) {
  useEffect(() => {

    if (!clientId || !planId) {
      console.error("🔍 STEP 5.0: Missing clientId/planId for PayPal");
      return;
    }

    const containerId = "paypal-button-container-" + planId;
    let cancelled = false;
    const script = document.createElement("script");
    script.src = ("https://www.paypal.com/sdk/js?client-id=" + clientId + "&vault=true&intent=subscription");
    script.setAttribute("data-sdk-integration-source", "button-factory");
    
    script.addEventListener("load", () => {
      
      if (cancelled) return;
      const container = document.getElementById(containerId);
      if (!container) {
        return;
      }
      if (window.paypal) {
        
        window.paypal.Buttons({
          style: {
            shape: "pill",
            color: isSandbox ? "white" : "gold",
            layout: "vertical",
            label: "paypal",
          },
          createSubscription: function (data, actions) {
            
            return actions.subscription.create({
              plan_id: planId,
            }).then((subscription) => {
              return subscription;
            }).catch((error) => {
              console.error("🔍 STEP 6.6: PayPal subscription creation failed:", error);
              throw error;
            });
          },
          onApprove: function (data, actions) {
            setSubscriptionID(data.subscriptionID, planId);
            // Fire Purchase as early as possible; fetch real price if possible
            try {
              const backendUrl = `${process.env.REACT_APP_BACKEND_URL}/graphql`;
              const headers = { 'Content-Type': 'application/json' };
              const token = localStorage.getItem('token');
              if (token) headers['Authorization'] = `Bearer ${token}`;
              const body = JSON.stringify({
                query: `
                  query GetPaypalPlanDetails($planId: String!) {
                    getPaypalPlanDetails(planId: $planId)
                  }
                `,
                variables: { planId }
              });
              fetch(backendUrl, { method: 'POST', headers, credentials: 'include', body })
                .then(r => r.json())
                .then(j => {
                  const raw = j.data?.getPaypalPlanDetails;
                  const plan = (typeof raw === 'string') ? JSON.parse(raw) : raw;
                  const pricing = plan?.billing_cycles?.[0]?.pricing_scheme?.fixed_price;
                  const value = pricing?.value ? parseFloat(pricing.value) : 19.99;
                  const currency = pricing?.currency_code || 'USD';
                  trackPurchase(value, currency, { method: 'paypal', plan: 'monthly' });
                })
                .catch(() => {
                  trackPurchase(19.99, 'USD', { method: 'paypal', plan: 'monthly' });
                });
            } catch (_) {
              trackPurchase(19.99, 'USD', { method: 'paypal', plan: 'monthly' });
            }
          },
          onError: function (err) {
            console.error("🔍 STEP 6.12: PayPal Error occurred:", err);
          },
          onCancel: function (data) {
            
          }
        }).render("#" + containerId).then(() => {
          
        }).catch((error) => {
          console.error("🔍 STEP 5.9: PayPal button render failed:", error);
        });
      } else {
        console.error("🔍 STEP 5.10: PayPal SDK not available after script load");
      }
    });
    
    script.addEventListener("error", (error) => {
      console.error("🔍 STEP 5.11: PayPal SDK script failed to load:", error);
    });
    
    document.body.appendChild(script);

    return () => {
      cancelled = true;
      try {
        document.body.removeChild(script);
      } catch (_) {}
    };
  }, [clientId, planId, isSandbox, setSubscriptionID]);

  return <><div className="PayPalSubscriptionButtons " id={"paypal-button-container-" + planId}></div></>
}

// after sandbox purchase: I-RVD94NR9A71D
// I-0B8G9D8E5C1A